import React from "react";
import { useTranslation } from "react-i18next";
import { useBrandingContext } from "context/BrandingContext";
import { ToolsIcon } from "@hugeicons-pro/core-stroke-rounded";
import StatusPage from "components/common/StatusPage";

const Maintenance: React.FC = () => {
  const { t } = useTranslation();
  const { platform } = useBrandingContext();
  const supportEmail = platform?.email || "support@outpave.com";

  return (
    <StatusPage
      title={t("Maintenance in Progress")}
      message={t("MaitenanceScreenDescription")}
      icon={ToolsIcon}
      // This page is where `Redirect` sends anyone it could not resolve a
      // landing route for, so retrying means running that resolution again.
      // Reloading would just re-render this page: /maintenance is a real route
      // and matches itself. A full navigation rather than `navigate()`, so the
      // user query starts from nothing rather than from a cached error.
      action={{
        label: t("Try again"),
        onClick: () => {
          window.location.href = "/redirect";
        },
      }}
      supportEmail={supportEmail}
    />
  );
};

export default Maintenance;
